<template>
  <img :src=icons[icon] alt="Icon">
</template>


<script>

// +++++++++++++++++++++++ BLUE ICONS ++++++++++++++++++++++++++++++++
import addBlue from '../../assets/images/icons/add--blue.svg';
import arrowDownBlue from '../../assets/images/icons/arrow-down--blue.svg';
import arrowLeftBlue from '../../assets/images/icons/arrow-left--blue.svg';
import arrowRightBlue from '../../assets/images/icons/arrow-right--blue.svg';
import arrowUpBlue from '../../assets/images/icons/arrow-up--blue.svg';
import attentionBlue from '../../assets/images/icons/attention--blue.svg';
import backArrowBlue from '../../assets/images/icons/back-arrow--blue.svg';
import burgerBlue from '../../assets/images/icons/burger--blue.svg';
import checkBlue from '../../assets/images/icons/check--blue.svg';
import clockBlue from '../../assets/images/icons/clock--blue.svg';
import closeBlue from '../../assets/images/icons/close--blue.svg';
import computerBlue from '../../assets/images/icons/computer--blue.svg';
import editBlue from '../../assets/images/icons/edit--blue.svg';
import fileBlue from '../../assets/images/icons/file--blue.svg';
import fileAddBlue from '../../assets/images/icons/file-add--blue.svg';
import filterBlue from '../../assets/images/icons/filter--blue.svg';
import folderBlue from '../../assets/images/icons/folder--blue.svg';
import gridBlue from '../../assets/images/icons/grid--blue.svg';
import hintBlue from '../../assets/images/icons/hint--blue.svg';
import idCardBlue from '../../assets/images/icons/id-card--blue.svg';
import listBlue from '../../assets/images/icons/list--blue.svg';
import lockblue from '../../assets/images/icons/lock--blue.svg';
import loginBlue from '../../assets/images/icons/login--blue.svg';
import noComputerBlue from '../../assets/images/icons/no-computer--blue.svg';
import openBlue from '../../assets/images/icons/open--blue.svg';
import phoneBlue from '../../assets/images/icons/phone--blue.svg';
import questionBlue from '../../assets/images/icons/question--blue.svg';
import recentBlue from '../../assets/images/icons/recent--blue.svg';
import resetBlue from '../../assets/images/icons/reset--blue.svg';
import routeBlue from '../../assets/images/icons/route--blue.svg';
import searchBlue from '../../assets/images/icons/search--blue.svg';
import sendBlue from '../../assets/images/icons/send--blue.svg';
import trashBlue from '../../assets/images/icons/trash--blue.svg';
import upDownBlue from '../../assets/images/icons/up-down--blue.svg';
import userBlue from '../../assets/images/icons/user--blue.svg';
import userFilledBlue from '../../assets/images/icons/user-filled--blue.svg';
import waitBlue from '../../assets/images/icons/wait--blue.svg';
import fontBlue from '../../assets/images/icons/font--blue.svg';
import contrastBlue from '../../assets/images/icons/contrast--blue.svg';

const blueIcons = {
  add: addBlue,
  arrowDown: arrowDownBlue,
  arrowLeft: arrowLeftBlue,
  arrowRight: arrowRightBlue,
  arrowUp: arrowUpBlue,
  attention: attentionBlue,
  backArrow: backArrowBlue,
  burger: burgerBlue,
  check: checkBlue,
  clock: clockBlue,
  close: closeBlue,
  computer: computerBlue,
  edit: editBlue,
  file: fileBlue,
  fileAdd: fileAddBlue,
  filter: filterBlue,
  folder: folderBlue,
  grid: gridBlue,
  hint: hintBlue,
  idCard: idCardBlue,
  list: listBlue,
  lock: lockblue,
  login: loginBlue,
  noComputer: noComputerBlue,
  open: openBlue,
  phone: phoneBlue,
  question: questionBlue,
  recent: recentBlue,
  reset: resetBlue,
  route: routeBlue,
  search: searchBlue,
  send: sendBlue,
  trash: trashBlue,
  upDown: upDownBlue,
  user: userBlue,
  userFilled: userFilledBlue,
  wait: waitBlue,
  font: fontBlue,
  contrast: contrastBlue,
};

// +++++++++++++++++++++++ GREEN ICONS ++++++++++++++++++++++++++++++++
import arrowDownGreen from '../../assets/images/icons/arrow-down--green.svg';
import arrowLeftGreen from '../../assets/images/icons/arrow-left--green.svg';
import arrowRightGreen from '../../assets/images/icons/arrow-right--green.svg';
import arrowUpGreen from '../../assets/images/icons/arrow-up--green.svg';
import burgerGreen from '../../assets/images/icons/burger--green.svg';
import checkGreen from '../../assets/images/icons/check--green.svg';
import resetGreen from '../../assets/images/icons/reset--green.svg';

const greenIcons = {
  arrowDown: arrowDownGreen,
  arrowLeft: arrowLeftGreen,
  arrowRight: arrowRightGreen,
  arrowUp: arrowUpGreen,
  burger: burgerGreen,
  check: checkGreen,
  reset: resetGreen,
}

// +++++++++++++++++++++++ WHITE ICONS ++++++++++++++++++++++++++++++++
import closeWhite from '../../assets/images/icons/close--white.svg';
import searchWhite from '../../assets/images/icons/search--white.svg';

const whiteIcons = {
  close: closeWhite,
  search: searchWhite,
}

// +++++++++++++++++++++++ GREY ICONS ++++++++++++++++++++++++++++++++
import idCardGrey from '../../assets/images/icons/id-card--grey.svg';
import invalidGrey from '../../assets/images/icons/invalid--grey.svg';
import lockGrey from '../../assets/images/icons/lock--grey.svg';
import waitGrey from '../../assets/images/icons/wait--grey.svg';

const greyIcons = {
  idCard: idCardGrey,
  invalid: invalidGrey,
  lock: lockGrey,
  wait: waitGrey,
}

// +++++++++++++++++++++++ RED ICONS ++++++++++++++++++++++++++++++++
import invalidRed from '../../assets/images/icons/invalid--red.svg';

const redIcons = {
  invalid: invalidRed,
}

// +++++++++++++++++++++++ DETAILED ICONS ++++++++++++++++++++++++++++++++
import augsburg from '../../assets/images/icons/detailed/augsburg.svg';
import auth from '../../assets/images/icons/detailed/auth.svg';
import build from '../../assets/images/icons/detailed/build.svg';
import car from '../../assets/images/icons/detailed/car.svg';
import certificateFile from '../../assets/images/icons/detailed/certificate-file.svg';
import certificate from '../../assets/images/icons/detailed/certificate.svg';
import chat from '../../assets/images/icons/detailed/chat.svg';
import checkAntrag from '../../assets/images/icons/detailed/check-antrag.svg';
import checkForm from '../../assets/images/icons/detailed/check-form.svg';
import children from '../../assets/images/icons/detailed/children.svg';
import correct from '../../assets/images/icons/detailed/correct.svg';
import docBox from '../../assets/images/icons/detailed/doc-box.svg';
import education from '../../assets/images/icons/detailed/education.svg';
import finance from '../../assets/images/icons/detailed/finance.svg';
import folder from '../../assets/images/icons/detailed/folder.svg';
import getMoney from '../../assets/images/icons/detailed/get-money.svg';
import healthcare from '../../assets/images/icons/detailed/healthcare.svg';
import idea from '../../assets/images/icons/detailed/idea.svg';
import insurance from '../../assets/images/icons/detailed/insurance.svg';
import letter from '../../assets/images/icons/detailed/letter.svg';
import love from '../../assets/images/icons/detailed/love.svg';
import migration from '../../assets/images/icons/detailed/migration.svg';
import moneyBag from '../../assets/images/icons/detailed/money-bag.svg';
import news from '../../assets/images/icons/detailed/news.svg';
import office from '../../assets/images/icons/detailed/office.svg';
import onlineBook from '../../assets/images/icons/detailed/online-book.svg';
import onlineForm from '../../assets/images/icons/detailed/online-form.svg';
import parents from '../../assets/images/icons/detailed/parents.svg';
import perlachturm from '../../assets/images/icons/detailed/perlachturm.svg';
import personalData from '../../assets/images/icons/detailed/personal-data.svg';
import phone from '../../assets/images/icons/detailed/phone.svg';
import postBox from '../../assets/images/icons/detailed/post-box.svg';
import school from '../../assets/images/icons/detailed/school.svg';
import settings from '../../assets/images/icons/detailed/settings.svg';
import signature from '../../assets/images/icons/detailed/signature.svg';
import spacecraft from '../../assets/images/icons/detailed/spacecraft.svg';
import talk from '../../assets/images/icons/detailed/talk.svg';
import taxes from '../../assets/images/icons/detailed/taxes.svg';
import university from '../../assets/images/icons/detailed/university.svg';
import upload from '../../assets/images/icons/detailed/upload.svg';
import weather from '../../assets/images/icons/detailed/weather.svg';
import webcam from '../../assets/images/icons/detailed/webcam.svg';
import work from '../../assets/images/icons/detailed/work.svg';
import computer from '../../assets/images/icons/detailed/computer.svg';

const detailedIcons = {
  augsburg,
  auth,
  build,
  car,
  certificateFile,
  certificate,
  chat,
  checkAntrag,
  checkForm,
  children,
  correct,
  docBox,
  education,
  finance,
  folder,
  getMoney,
  healthcare,
  idea,
  insurance,
  letter,
  love,
  migration,
  moneyBag,
  news,
  office,
  onlineBook,
  onlineForm,
  parents,
  perlachturm,
  personalData,
  computer,
  phone,
  postBox,
  school,
  settings,
  signature,
  spacecraft,
  talk,
  taxes,
  university,
  upload,
  weather,
  webcam,
  work,
}


export default {
  name: "Icon",
  props: {
    icon: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: 'blue',
      validator(value) {
        return ['blue', 'white', 'green', 'grey', 'red', 'detailed'].indexOf(value) !== -1;
      }
    }
  },
  computed: {
    icons() {
      if (this.color === 'blue') {
        return blueIcons;
      } else if (this.color === 'white') {
        return whiteIcons;
      } else if (this.color === 'green') {
        return greenIcons;
      } else if (this.color === 'red') {
        return redIcons;
      } else if (this.color === 'grey') {
        return greyIcons;
      }
      return detailedIcons;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Icon/Icon.vue